class FalcoP58 extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-p58-slide]')];
    this.thumbs = [...this.querySelectorAll('[data-p58-thumb]')];
    this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
    this.form = this.querySelector('[data-p58-form]');
    this.mainSubmit = this.querySelector('[data-p58-submit]');
    this.message = this.querySelector('[data-p58-message]');
    this.paidPreview = this.querySelector('[data-p58-paid-preview] img');
    this.freePreview = this.querySelector('[data-p58-free-preview] img');
    this.freeSelect = this.querySelector('[data-p58-free-select]');
    this.stickyImage = this.querySelector('[data-p58-sticky-image]');
    this.bindGallery();
    this.bindVariants();
    this.bindOfferActions();
    this.bindForm();
    this.bindSticky();
  }

  bindGallery() {
    if (!this.slides.length) return;
    this.querySelector('[data-p58-prev]')?.addEventListener('click', () => this.showSlide(this.index - 1));
    this.querySelector('[data-p58-next]')?.addEventListener('click', () => this.showSlide(this.index + 1));
    this.thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => this.showSlide(index)));
  }

  showSlide(nextIndex) {
    this.index = (nextIndex + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, index) => slide.classList.toggle('is-active', index === this.index));
    this.thumbs.forEach((thumb, index) => {
      const active = index === this.index;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
    });
    const counter = this.querySelector('[data-p58-current]');
    if (counter) counter.textContent = String(this.index + 1);
  }

  bindVariants() {
    const hidden = this.querySelector('[data-p58-variant-id]');
    this.querySelectorAll('[data-p58-paid]').forEach((input) => {
      input.addEventListener('change', () => {
        hidden.value = input.value;
        this.querySelectorAll('[data-p58-price]').forEach((node) => { node.textContent = input.dataset.price; });
        if (input.dataset.galleryIndex) this.showSlide(Number(input.dataset.galleryIndex));
        this.updatePreview(this.paidPreview, input.dataset.imageSrc, input.dataset.imageAlt);
        this.updatePreview(this.stickyImage, input.dataset.imageSrc, '');
      });
    });
    this.freeSelect?.addEventListener('change', () => {
      const option = this.freeSelect.selectedOptions[0];
      this.updatePreview(this.freePreview, option?.dataset.imageSrc, option?.dataset.imageAlt);
    });
  }

  updatePreview(image, source, alt) {
    if (!image || !source) return;
    image.src = source;
    image.alt = alt || '';
  }

  bindOfferActions() {
    this.querySelectorAll('[data-p58-scroll-buy]').forEach((button) => {
      button.addEventListener('click', () => {
        this.form?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
    this.querySelector('[data-p58-sticky-submit]')?.addEventListener('click', () => this.mainSubmit?.click());
  }

  bindForm() {
    if (!this.form) return;
    this.form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!this.form.reportValidity()) return;
      const original = this.mainSubmit.textContent;
      this.mainSubmit.disabled = true;
      this.mainSubmit.textContent = 'Ajout en cours…';
      if (this.message) this.message.textContent = '';

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(this.form),
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || 'Ajout impossible.');
        if (this.message) this.message.textContent = 'Vos deux coloris ont été ajoutés au panier.';
        window.location.href = `${root}cart`;
      } catch (error) {
        if (this.message) this.message.textContent = error.message;
        this.mainSubmit.disabled = false;
        this.mainSubmit.textContent = original;
      }
    });
  }

  bindSticky() {
    const sticky = this.querySelector('[data-p58-sticky]');
    if (!sticky || !this.mainSubmit || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 });
    observer.observe(this.mainSubmit);
  }
}

if (!customElements.get('falco-p58')) customElements.define('falco-p58', FalcoP58);
